import React, { useContext, useMemo } from "react";
import { contexto } from "./CustomProvider";

export default function WindyMap() {
    const { thisDeviceData } = useContext(contexto);
    const location = thisDeviceData?.location;

    const coords = useMemo(() => {
        if (!location) {
            return {
                lat: -24.489616,
                lon: -46.675304,
            };
        }

        return {
            lat: Number(location.latitude),
            lon: Number(location.longitude),
        };
    }, [location]);

    const src = useMemo(() => {
        return `https://embed.windy.com/embed2.html?lat=${coords.lat}&lon=${coords.lon}&zoom=9&level=surface&overlay=rain&product=ecmwf&detail=false&type=map&location=coordinates&metricWind=default&metricTemp=default`;
    }, [coords]);

    if (!coords) {
        return <div>Cargando...</div>;
    }

    return (
        <iframe
            key={`${coords.lat}-${coords.lon}`}
            title="CLIMA WINDY"
            width="100%"
            height="100%"
            frameBorder="0"
            src={src}
        />
    );
}
